import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Liberty from "@/pages/Liberty";

export const Route = createFileRoute("/liberty")({
  head: () => routeHead('AGAPE Liberty — Content & AI Visibility', META_DESCRIPTIONS.liberty.en, '/liberty'),
  component: Liberty,
});
